import { useNow } from "@/hooks/useNow";
import { hhStatus, fmtDur } from "@/lib/hh";

const STYLES = {
  open: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  ending: "bg-amber-500/15 text-amber-300 border-amber-500/50",
  closed: "bg-zinc-800/80 text-zinc-400 border-zinc-700",
};
const LABEL = { open: "Open", ending: "Ending Soon", closed: "Closed" };

export function StatusBadge({ venue, testId }) {
  const now = useNow(1000);
  const st = hhStatus(venue, now);
  let detail = st.label;
  if (st.seconds != null) detail = `ends in ${fmtDur(st.seconds)}`;
  else if (st.startsIn != null) detail = `starts in ${fmtDur(st.startsIn)}`;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-bold ${STYLES[st.state]}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${st.state === "closed" ? "bg-zinc-500" : st.state === "ending" ? "bg-amber-400 animate-pulse" : "bg-emerald-400 animate-pulse"}`} />
      {LABEL[st.state]}
      <span className="font-medium tabular-nums opacity-80">· {detail}</span>
    </span>
  );
}
